module.exports = __webpack_public_path__ + "static/scale-model-of-double-barrel-cannon-in-athens-georgia-b6c5d720050bfd09c132b9d5a2ad667c.png";